import RolesManagement from '@src/main/modules/roles/ui/components/RolesManagement';

const RolesManagementPage = () => <RolesManagement />;

export default RolesManagementPage;
